// extracted by mini-css-extract-plugin
export default {"forModelView":"forModelView___FQyA2","darkBtn":"darkBtn___JOCRy"};